import React from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import useRolesPermissions from "hooks/useRolesPermissions";
import { useStyles } from "../AreasList.styles";
import { IActionButtonsProps } from "./interfaces";

export const ActionButtons: React.FC<IActionButtonsProps> = ({ onEdit, onDelete, showButtons = true }) => {
    const classes = useStyles();
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();

    if (!showButtons || !CORPORATE_PERMISSIONS?.corporationPermissions?.canEditMachineCenters) {
        return null;
    }

    return (
        <>
            <IconButton
                size="small"
                className={classes.editIcon}
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                onMouseUp={(e) => {
                    e.stopPropagation();
                    onEdit(e);
                }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <EditIcon />
            </IconButton>
            <IconButton
                size="small"
                className={classes.editIcon}
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                onMouseUp={(e) => {
                    e.stopPropagation();
                    onDelete(e);
                }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <DeleteIcon />
            </IconButton>
        </>
    );
};
